import unescapedText from 'I18n/utils/unescapedText';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Big from 'UIComponents/elements/Big';
import Small from 'UIComponents/elements/Small';
import UIImage from 'UIComponents/image/UIImage';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import UITruncateMultiline from 'UIComponents/text/UITruncateMultiline';
import { getCategoryI18nKey } from 'marketplace-ui-common/utils/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MAX_ICON_WIDTH = 48;
export default function AppSearchBarResult({
  category,
  companyName,
  iconUrl,
  isMobileView,
  name,
  tagline
}) {
  return /*#__PURE__*/_jsxs(UIMediaObject, {
    itemLeft: /*#__PURE__*/_jsx("div", {
      style: {
        width: MAX_ICON_WIDTH
      },
      children: /*#__PURE__*/_jsx(UIImage, {
        src: iconUrl
      })
    }),
    children: [/*#__PURE__*/_jsxs("div", {
      "data-selenium-id": `${name}-typeahead-search-result`,
      className: "m-bottom-1",
      children: [/*#__PURE__*/_jsx(Big, {
        className: "display-block",
        children: /*#__PURE__*/_jsx("b", {
          children: name
        })
      }), /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-ui-apps-core.appSearchBarResult.companyName",
          options: {
            companyName
          }
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "m-bottom-2",
      children: /*#__PURE__*/_jsx(UITruncateMultiline, {
        maxChars: 55,
        text: tagline,
        style: {
          whiteSpace: 'pre-wrap'
        },
        tagName: "div"
      })
    }), !isMobileView && /*#__PURE__*/_jsx(Small, {
      use: "help",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-ui-apps-core.appSearchBarResult.inCategory",
        options: {
          category: unescapedText(getCategoryI18nKey(category))
        }
      })
    })]
  });
}